export default __webpack_public_path__ + "static/media/exitfund.a81f03e3.svg";